import React, { useState, useEffect } from 'react'
import moment from 'moment'

import { Flex } from 'reflexbox/styled-components'
import { Link } from 'react-router-dom'
import { useHistory } from 'react-router-dom'
import { Formik, Form } from 'formik'

import Button from 'components/Button'
import DataListingTable from 'components/DataListingTable'
import { Text } from 'components/Typography'
import { TextField, SelectField, DateRangePickerField } from 'components/Form/Fields'

import { getCouponsList } from 'services/coupons'
import { toast } from 'react-toastify'
import { formatCurrency } from 'utils/formatters'

const columns = [
  {
    Header: 'ID',
    accessor: 'id',
  },
  {
    Header: 'Descrição',
    accessor: 'description',
  },
  {
    Header: 'Código',
    accessor: 'code',
  },
  {
    Header: 'Valor',
    accessor: 'value',
  },
  {
    Header: 'Validade',
    accessor: 'due_date',
  },
  {
    Header: 'Status',
    accessor: 'status',
  },
]

const List = () => {
  const [coupons, setCoupons] = useState([])
  const [filters, setFilters] = useState({})
  const [sortBy, setSortBy] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [pagination, setPagination] = useState({
    currentPage: 1,
    pageSize: 10,
    totalPages: 1,
    totalRecords: 0,
  })

  const history = useHistory()

  const handleTableDataFetch = ({ sortBy, currentPage, pageSize }) => {
    setSortBy(sortBy)
    setPagination({ ...pagination, currentPage, pageSize })
  }

  const handleFilters = ({ search, date, status }) => {
    setFilters({
      ...(search && { search }),
      ...(date?.startDate && { first_date: moment(date.startDate._d).format('YYYY-MM-DD') }),
      ...(date?.endDate && { last_date: moment(date.endDate._d).format('YYYY-MM-DD') }),
      ...(status && { status: status.value }),
    })
  }

  useEffect(() => {
    const fetchCoupons = async () => {
      try {
        setIsLoading(true)
        const data = await getCouponsList({ pagination, sortBy, ...filters })

        const formattedData = data.coupons.map(item => ({
          id: (
            <Text as={Link} color='grays.N800' to={`/staff/promotions/coupons/${item.id}`}>
              {item.id}
            </Text>
          ),
          description: item.description ? item.description : '-',
          code: item.code ? item.code : '-',
          value: formatCurrency(item.value),
          due_date: `${moment(item.initial_date).format('DD/MM/YYYY')} - ${moment(item.expiration_date).format(
            'DD/MM/YYYY',
          )}`,
          status: item.active ? 'Ativo' : 'Inativo',
        }))

        setCoupons(formattedData)
        setPagination(data.pagination)
      } catch (e) {
        console.log(e)
        toast.error('Erro ao carregar dados!')
      } finally {
        setIsLoading(false)
      }
    }

    if (sortBy) {
      fetchCoupons()
    }
  }, [filters, sortBy, pagination.currentPage, pagination.pageSize])

  return (
    <>
      <Flex width={1} alignItems='center' justifyContent='space-between'>
        <h1>Cupons</h1>
        <Button size='auto' outlided onClick={() => history.push('/staff/promotions/coupons/new')}>
          Cadastrar Cupom
        </Button>
      </Flex>
      <Formik
        initialValues={{
          search: '',
          date: {
            startDate: '',
            endDate: '',
          },
          status: '',
        }}
        onSubmit={handleFilters}
      >
        <Form>
          <Flex width={1} alignItems='center' mb={24}>
            <TextField name='search' placeholder='Pesquisa' label='BUSCAR' mr={12} />
            <DateRangePickerField minWidth={282} name='date' label='VALIDADE' mr={12} />
            <SelectField
              minWidth={180}
              name='status'
              placeholder='Status'
              label='STATUS'
              options={[
                { label: 'Ativo', value: 'True' },
                { label: 'Inativo', value: 'False' },
              ]}
              isClearable
              mr={12}
            />
            <Button variant='secondary' type='submit'>
              Filtrar
            </Button>
          </Flex>
        </Form>
      </Formik>
      <DataListingTable
        data={coupons}
        columns={columns}
        pagination={pagination}
        fetchData={handleTableDataFetch}
        loading={isLoading}
      />
    </>
  )
}

export default List
